import React, { useEffect, useMemo } from 'react'
import { SavedTransactions } from '../../../SavedTransactions'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

/**
 * Shared TransactionsTab for read-only display of saved transactions.
 * Used by all 3 public page types (land, building, estimate).
 * Renders SavedTransactions from pre-fetched entity data.
 */
export const TransactionsTab: React.FC = () => {
  const { entity } = useAnalysisMode()
  const { setActiveSection, updateSectionData } = useAnalysisMapSectionData()

  // Extract saved transactions from entity
  const savedTransactions = useMemo(() => {
    const transactionData =
      entity?.saved_transactions || entity?.savedTransactions || []
    return Array.isArray(transactionData) ? transactionData : []
  }, [entity])

  // Push transactions data to map context
  useEffect(() => {
    setActiveSection('transactions')
    if (savedTransactions.length > 0) {
      updateSectionData({ transactions: savedTransactions })
    }
  }, [savedTransactions, setActiveSection, updateSectionData])

  // Handle transaction click (no-op in read-only mode)
  const handleTransactionClick = () => {
    // In read-only mode, we don't have transaction detail panels
  }

  return (
    <SavedTransactions
      transactions={savedTransactions}
      onTransactionClick={handleTransactionClick}
      isLoading={false}
    />
  )
}
